import { type ReactNode } from 'react';
import { useIsAdmin } from '../useIsAdmin';

export function RequireAdmin({ children, fallback = null }: Readonly<{ children: ReactNode; fallback?: ReactNode }>) {
  const isAdmin = useIsAdmin();
  if (!isAdmin) return <>{fallback}</>;
  return <>{children}</>;
}
